import { createApp } from 'vue';
import { registerPlugins } from '@/utils/plugins.js'
import App from './App.vue';
import '@/assets/scss/main.scss';

const app = createApp(App);

registerPlugins(app, import.meta.env)

app.mount('#app-wrapper'); // Mount app
